import {
    CollectionCarousel,
    CollectionContentShape,
} from '@eventbrite/collection-carousel';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './collectionsBucket.scss';

export interface CollectionsBucketProps {
    currentPlace: string;
    content?: CollectionContentShape[];
    isBotRequest?: boolean;
    tld: string;
    trackGAEventOnPageUnload?: Function;
    trackGAEvent?: Function;
}

const CollectionHeader = () => (
    <div className="collection__featured-collections__carousel-header--title">
        <p className="eds-text-hs">{gettext('Hand-picked')}</p>
        <p className="eds-text-hm eds-text-color--primary-brand">
            {gettext('Collections')}
        </p>
    </div>
);

const CollectionSubtitle = () => (
    <div className="collection__featured-collections__carousel-header--subtitle">
        {gettext(
            'Discover more of the best in food, music, wellness, and more with our curated event collections',
        )}
    </div>
);

export const CollectionsBucket: React.FunctionComponent<
    CollectionsBucketProps
> = (props) => {
    const [isCollectionCarouselRendering, setIsCollectionCarouselRendering] =
        React.useState(!!props.content);

    //TODO: investigate fallback renderinig that will ~match height of the container / set a max top height
    return (
        <div
            className={`featured-collections-bucket ${
                isCollectionCarouselRendering ? '' : 'eds-hide'
            }`}
        >
            <div className="collections-bucket__container">
                <CollectionCarousel
                    collectionCardContainerClassname="collections-bucket__card"
                    content={props.content}
                    currentPlace={props.currentPlace}
                    isBotRequest={props.isBotRequest}
                    tld={props.tld}
                    cardsPerSlide={{ desktop: 2, tablet: 2 }}
                    headerTitle={<CollectionHeader />}
                    headerSubtitle={<CollectionSubtitle />}
                    lazilyRenderOffScreenElements={true}
                    onMount={(isRendering) =>
                        setIsCollectionCarouselRendering(isRendering)
                    }
                />
            </div>
        </div>
    );
};
